// ShopPage.jsx
import { ChevronDown } from "lucide-react";
import { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/customer/subscreens/shop/ShopPage.css";
import CleanPageBanner from "../../../../components/customer/pagebanner/PageBanner";
import ShopCard from "../../../../components/customer/shopcard/ShopCard";
import AppContext from "../../../../contexts/AppContext";
import axios from "axios";

const ShopPage = () => {
  const navigate = useNavigate();
  const [selectedCity, setSelectedCity] = useState("All Cities");
  const [appliedCity, setAppliedCity] = useState("All Cities");
  const [currentPage, setCurrentPage] = useState(1);
  const { baseUrl, baseUrlForFiles, setSelectedShop } = useContext(AppContext);

  const [shops, setShops] = useState([]);

  const viewShops = () => {
    axios
      .get(`${baseUrl}/customer/shop/viewShops`)
      .then((response) => {
        setShops(response.data.shops);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewShops();
  }, []);

  // Dynamic city list from actual shops data
  const cities = useMemo(() => {
    const uniqueCities = [
      ...new Set(shops.map((shop) => shop.city).filter(Boolean)),
    ];
    return ["All Cities", ...uniqueCities.sort()];
  }, [shops]);

  const filteredShops = shops.filter((shop) => {
    return appliedCity === "All Cities" || shop.city === appliedCity;
  });

  const shopsPerPage = 6;
  const totalPages = Math.ceil(filteredShops.length / shopsPerPage);
  const startIndex = (currentPage - 1) * shopsPerPage;
  const displayedShops = filteredShops.slice(
    startIndex,
    startIndex + shopsPerPage,
  );

  const handleViewShop = (shop) => {
    setSelectedShop(shop);
    localStorage.setItem("selectedShop", JSON.stringify(shop));
    navigate("/shop-detail");
  };

  const handleSearch = () => {
    setAppliedCity(selectedCity);
    setCurrentPage(1);
  };

  return (
    <>
      <div className="category-page-container">
        <CleanPageBanner
          title="Our Shops"
          subtitle="Discover amazing shops from different cities"
          buttonText="Explore Now"
          buttonLink="/products"
          breadcrumbs={[{ label: "Shop" }]}
        />

        <div className="shop-page-content-new">
          {/* City Dropdown and Search Button */}
          <div className="city-search-section">
            <div className="city-dropdown-container">
              <select
                className="city-dropdown"
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.target.value)}
              >
                {cities.map((city) => (
                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              <ChevronDown className="dropdown-icon" size={20} />
            </div>

            <button className="search-btn-only" onClick={handleSearch}>
              Search
            </button>
          </div>

          {/* Results Info */}
          <div className="results-header">
            <p className="results-info">
              Showing <strong>{displayedShops.length}</strong> of{" "}
              <strong>{filteredShops.length}</strong> shops
              {appliedCity !== "All Cities" && ` in ${appliedCity}`}
            </p>
          </div>

          {/* Shop Cards Grid */}
          <div className="shop-cards-grid">
            {displayedShops.map((shop) => (
              <ShopCard key={shop.id} shop={shop} onViewShop={handleViewShop} />
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                className="page-btn"
                onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
              >
                ←
              </button>
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className="page-btn"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                }
                disabled={currentPage === totalPages}
              >
                →
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ShopPage;